import axios from 'axios';
import AppConfig from "../../../AppConfig";

let URL = AppConfig.HOST_API() + 'bok/zgl/';

export default {

    pobierzZgloszenia(page,size,typ,status,czyMoznaZwrocic,email,nrBil) {
        return axios({
            method: 'get',
            url: URL+'?typ='+typ+'&status='+status+'&czyMoznaZwrocic='+czyMoznaZwrocic+'&email='+email+'&nrBil='+nrBil+'&page='+page+'&size='+size,
        });
    },

    pobierzZgloszenie(idZgl) {
        return axios({
            method: 'get',
            url: URL+'zgloszenie/'+idZgl,
        });
    },

    odpowiedzNaZgloszenie(idZgl,data) {
        return axios({
            url: URL +'zgloszenie/'+idZgl,
            method: 'post',
            data: JSON.stringify(data),
        });
    },

    odczytajZgloszenie(idZgl){
        return axios({
            url: URL +'zgloszenie/'+idZgl+'/odczytano',
            method: 'post',
        });
    },

    realizujZgloszenie(idZgl){
        return axios({
            url: URL +'zgloszenie/'+idZgl+'/wrealizacji',
            method: 'post',
        });
    },

    zamknijZgloszenie(idZgl){
        return axios({
            url: URL +'zgloszenie/'+idZgl+'/zamknij',
            method: 'post',
        });
    },

    edytujTematZgloszenia(idZgl,temat){
        return axios({
            //http://linuxdev.top:8084/api/bok/zgl/zgloszenie/161/temat?temat=aaaa
            url: URL +'zgloszenie/'+idZgl+'/temat?temat='+temat,
            method: 'put',
        });
    }

}



// WEBPACK FOOTER //
// ./src/modules/klienciConfig/eBOK/EBOKService.js